// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3c43e5e0","455":"604d39bd","977":"0fc217f9"}[chunkId] + ".chunk.js";
};